import React, { Component } from 'react';
import scrollbooster from 'scrollbooster';
import pick from 'lodash/pick';
import omit from 'lodash/omit';


const scrollboosterProps = [
  'mode',
  'bounce',
  'textSelection',
  'friction',
  'bounceForce',
  'emulateScroll',
  'onUpdate',
  'onClick',
  'shouldScroll'
];

class ScrollBooster extends Component {
  
  constructor (props){
    super(props);
    this.viewport = null;
    this.scrollbooster = null;
    this.onEndTimeout = null
    
    this.setViewportRef = element => {
      this.viewport = element;
    };
  }
  
  componentWillReceiveProps (nextProps){
    const { bounce, position, onUpdateEnd, x, y } = this.props
    
    if ( onUpdateEnd && (nextProps.x !== x || nextProps.y !== y) ){
      if (this.onEndTimeout)
        clearTimeout(this.onEndTimeout)
      
      this.onEndTimeout = setTimeout(this.onUpdateEnd.bind(this), 50);  
    }
    
    if (bounce === false && nextProps.position !== position){
      this.setPosition(nextProps.position);
    }
  }
  
  onUpdateEnd (){
    const { onUpdateEnd } = this.props
    if (!this.scrollbooster || !onUpdateEnd)
      return
    const { isRunning } = this.scrollbooster.getUpdate();
    
    if (!isRunning)
      onUpdateEnd()
    else{
      if (!this.onEndTimeout)
        clearTimeout(this.onEndTimeout)
      this.onEndTimeout = setTimeout(this.onUpdateEnd.bind(this), 50);
    }
  }
  
  initBooster (){
    const { x, y } = this.props
    const boosterParams = pick(this.props, scrollboosterProps)
    
    if (!this.viewport)
      return
    
    if (this.viewport.offsetWidth <= 0){
      return setTimeout(this.initBooster.bind(this), 300);
    }
    
    if (this.scrollbooster)
      this.scrollbooster.destroy()
    
    
    this.scrollbooster = new scrollbooster({
      ...boosterParams,
      viewport: this.viewport
    })
    
    if (x || y){
      this.scrollbooster.setPosition({x, y});
    }
  }
  
  setPosition(position){
    this.scrollbooster && this.scrollbooster.setPosition(position);
  }
  
  componentDidMount (){
    this.initBooster()
    // window.addEventListener("resize", this.scrollbooster.updateMetrics);
  }
  
  componentWillUnmount (){
    // window.addEventListener("resize", this.scrollbooster.updateMetrics);
    if (this.scrollbooster)
      this.scrollbooster.destroy()
  }
 
  render () {
    const { children } = this.props;
    const viewportProps = omit(this.props, [...scrollboosterProps, 'onUpdateEnd', 'position', 'children', 'ref', 'x', 'y']);
    
    return (<div {...viewportProps} ref={this.setViewportRef}>
      {children}
    </div>)
  }
};

export default ScrollBooster;


// WEBPACK FOOTER //
// ./src/components/helpers/ScrollBooster.js